import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-20 bg-white" data-id="element-201">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-202">
        <FadeIn data-id="element-203">
          <div className="prose prose-lg md:prose-xl text-gray-800 leading-[1.8]" data-id="element-204">
            <p className="first-letter:text-5xl first-letter:font-bold first-letter:text-amber-500 first-letter:mr-3 first-letter:float-left" data-id="element-205">
              Te levantas un lunes por la mañana, eliges tu pantalón favorito y,
              de repente, sucede: la cremallera no sube.
            </p>
            <p data-id="element-206">
              No es que hayas comido "tan mal" el fin de semana. Es que, después
              de los 40, las reglas han cambiado y tu cuerpo parece haber
              activado un freno de mano invisible.
            </p>
            <p data-id="element-207">
              Sientes que, hagas lo que hagas, tu metabolismo se ha vuelto vago.
              Te miras al espejo y no reconoces a la persona cansada que te
              devuelve la mirada.
            </p>
            <div className="p-6 my-8 border-l-4 border-amber-500 bg-amber-50/50 rounded-r-lg" data-id="element-208">
              <p className="m-0 font-medium text-gray-900" data-id="element-209">
                No es falta de voluntad; es una desconexión hormonal que las
                dietas tradicionales solo empeoran.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}